import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ngxCmArrayFilter'
})
export class ArrayFilterPipe implements PipeTransform {

  transform(value: Array<any>, args?: any): any {
    if (typeof args === 'string') {
      return value.filter(s => {
        return s === args;
      });
    } else if (typeof args === 'object') {
      let keys = Object.keys(args);
      return value.filter(s => {
        for (let key in args) {
          if (s[key] != args[key]) {
            return null;
          }
        }
        return s;
      });
    }
    return null;
  }

}
